/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchScansCreatedByUserResponse } from './search-scans-created-by-user-response';
import { SearchScansFacilityResponse } from './search-scans-facility-response';
import { SearchScansStatusResponse } from './search-scans-status-response';


export interface SearchScansResponse { 
    id: string;
    facility: SearchScansFacilityResponse;
    containersCount: number;
    scanResultsCount: number;
    createdByUser: SearchScansCreatedByUserResponse;
    status: SearchScansStatusResponse;
    createdDate: string;
}

